// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getOrgDomain } from '../utils/sessionStorage/orgDomain'

// Define a service using a base URL and expected endpoints
export const triageApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_PUBLIC_YOU_API_HOST,
    credentials: 'omit',
    mode: 'cors',
    prepareHeaders: headers => {
      headers.set('Accept', 'application/json')

      return headers
    },
  }),
  endpoints: builder => ({
    getInitData: builder.query({
      query: () => '/v2/triage/init',
    }),
    getLegalStatements: builder.query({
      query: id => `/legal-statements/${id}`,
    }),
    getResource: builder.query({
      query: id => `/v2/triage/resources/${id}?org_domain=${getOrgDomain()}`,
    }),
    getResources: builder.query({
      query: params => {
        return `/v3/triage/resources?${params}`
      },
    }),
  }),
  reducerPath: 'triageApi',
  tagTypes: ['resources', 'init'],
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetInitDataQuery,
  useGetLegalStatementsQuery,
  useGetResourcesQuery,
  useGetResourceQuery,
} = triageApi
